/**
 * confirm-request-dialog.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Types } from 'utils/constants';
import Dialog from 'components/dialog';


const useStyles = makeStyles(theme => ({
  confirmDialog: {
    '& .MuiDialogContent-root': {
      paddingTop: theme.spacing(2)
    }
  }
}));


// other handler requesting to be supervised by you
// other handler requesting to be trained by you
// other supervisor requesting to manage you as supervisor 

export default function ConfirmRequestDialog(props) {
  const {
    isOpen,
    onOk,
    onClose,
    request
  } = props;
  const classes = useStyles();


  return (
    <Dialog
      title={`Confirm Request`}
      titleIcon={`group-accept`}
      maxWidth='xs'
      fullWidth      
      className={classes.confirmDialog}
      open={isOpen}
      onOk={onOk}
      onClose={onClose}
    >
      {/* handler requesting you to supervise them */}
      {request?.role.id === Types.Role.SUPERVISOR &&
      <>
        {request.creator.name} has requested that you be their supervisor. 
        Approved supervisors can access handler training and deployment records.
        Click OK to confirm. 
      </>}

      {/* handler requesting you to train them */}
      {request?.role.id === Types.Role.TRAINER &&
      <>
        {request.creator.name} has requested that you be their trainer. 
        Approved trainers can access handler training records and create new training events and exercises. 
        Click OK to confirm.
      </>}

      {/* supervisor requesting to manage you as supervisor */}
      {request?.role.id === Types.Role.MANAGER &&
      <>
        {request.creator.name} has requested Management access to your account. 
        This will allow them to see the same training and deployment records for handlers that you have access to as a supervisor. 
        Note that this includes records for handlers that you supervise directly as well as any handler records that are 
        visible to you because you invited another supervisor to share their information. 
        Click OK to confirm.
      </>}
    </Dialog>
  );
}